import React, { Component } from 'react';
import { Col, Row, Form, FormGroup, Checkbox, ControlLabel, ButtonToolbar, Button, HelpBlock} from 'react-bootstrap';
import Select from "react-select";
import DatePicker from 'react-16-bootstrap-date-picker';
import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../../LoadingSpinner';

export class TmlUpdateSelectionForm extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            form: {
                referenceDate: props.referenceDate,
                plannings: {
                    schoolSeasonsPlanning: {
                        label: "Escolar",
                        planningEditions: []
                    },
                    nonSchoolSeasonsPlanning: {
                        label: "Não Escolar",
                        planningEditions: []
                    },
                    summerSeasonsPlanning: {
                        label: "Verão",
                        planningEditions: []
                    },
                },
                activeNetwork: ""
            },
            actions: {
                isLoadingEdition: true
            },
            parameters: {
                selectionTimeStamp: undefined,
                network: undefined,
                deleteSelections: 0
            },
            formErrors: {
                referenceDate: null,
                network: null
            }
        };
    }

    componentDidMount() {
        const { form } = this.state;

        const edition = this.context.getOwnEdition(false);
        edition.addObserver(this);

        edition.update(new Date(form.referenceDate));

        this.setState({
            edition: edition
        });
    }

    componentWillUnmount() {
        const { edition } = this.state;

        if (undefined !== edition) {
            edition.removeObserver(this);
        }
    }

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    getFormPropertyByLabel(label) {
        const { form } = this.state;
        let property = null;

        for (const key in form.plannings) {
            if (form.plannings.hasOwnProperty(key) && form.plannings[key].label === label) {
                property = key;
                break;
            }
        }

        return property;
    }

    getPlanningTypes() {
        const { form } = this.state;
        const { plannings } = form;
        const labels = [];

        for (const key in plannings) {
            if (plannings.hasOwnProperty(key)) {
                const { label } = plannings[key];
                labels.push(label);
            }
        }

        return labels;
    }

    sortItems(items, first = undefined) {
        const sortedItems = [];
        const uniqueItems = new Set();

        let sortOrder = this.getPlanningTypes() || [];

        if (first !== undefined) {
            sortOrder = this.setOrder(sortOrder, first);
        }

        for (const category of sortOrder) {
            const exactMatchItems = items.filter((element) =>
                element.name.toLowerCase().startsWith(category.toLowerCase())
            );

            exactMatchItems.forEach((item) => uniqueItems.add(item));

            const partialMatchItems = items.filter((element) =>
                element.name.toLowerCase().includes(category.toLowerCase()) &&
                !uniqueItems.has(element)
            );

            partialMatchItems.forEach((item) => uniqueItems.add(item));
        }

        uniqueItems.forEach((item) => sortedItems.push(item));

        return sortedItems;
    }

    setOrder(array, order) {
        if (array.length >= order) {
            const temp = array[0];
            array[0] = array[order];
            array[order] = temp;
        }
        return array;
    }

    getAllPlanningEditions(exceptType) {
        const { form } = this.state;
        const result = [];

        for (const type of this.getPlanningTypes()) {
            if (exceptType.label === type) {
                continue
            }
            const plannings = form.plannings[this.getFormPropertyByLabel(type)] ? form.plannings[this.getFormPropertyByLabel(type)].planningEditions : [];

            result.push(plannings);
        }

        return result;
    }

    getThisOrder(planningsType) {
        const sortOrder = this.getPlanningTypes() || [];
        const firstOrder = sortOrder.indexOf(planningsType.label);

        return firstOrder;
    }

    updateItems(items, selectedItems) {
        if (!selectedItems || selectedItems.length === 0) {
            return items;
        }

        const selectedIds = selectedItems.flatMap(arr => arr.map(obj => obj.id));
        const selectedNames = selectedItems.flatMap(arr => arr.map(obj => obj.name));

        const result = items.filter(item => !selectedIds.includes(item.id) && !selectedNames.includes(item.name));
        return result;
    }

    onSelectValue(selectedOption, property) {
        const { form } = this.state;

        form.plannings[property].planningEditions = selectedOption;

        this.setState({
            form: form
        });
    }

    onCheckValue(e, property) {
        const { parameters } = this.state;

        parameters[property] = e.target.checked ? 1 : 0;

        this.setState({
            parameters: parameters,
        });
    }

    onChangeReferenceDateChange(date) {
        const { form } = this.state;

        form.referenceDate = date;

        this.setState({
            form: form,
        }, () => {
            const { edition } = this.state;
            edition.update(new Date(date));
        });
    }

    onContinue() {
        if (this.validateForm()) {
            const { form, parameters } = this.state;

            for (const type of this.getPlanningTypes()) {
                const plannings = form.plannings[this.getFormPropertyByLabel(type)] ? form.plannings[this.getFormPropertyByLabel(type)].planningEditions : [];

                parameters[this.getFormPropertyByLabel(type)] = plannings.map(planning => planning.id).join(',');
            }
            parameters.selectionTimeStamp = new Date().getTime();

            this.props.onContinue(parameters);
        }
    }

    validateForm() {
        const { form, parameters } = this.state;
        const errors = {};

        if (!form.referenceDate) {
            errors.referenceDate = "Este campo não pode estar vazio.";
        }

        if (!parameters.network) {
            errors.network = "Este campo não pode estar vazio.";
        }

        this.setState({
            formErrors: errors
        });

        return Object.keys(errors).length === 0;
    }


    renderActiveNetworkFilter() {
        const { edition, parameters } = this.state;

        if (!edition.objects.network) {
            return null;
        }

        parameters.network = edition.objects.network.id;

        return (
            <div className="inline-labels padding-top-15">
                <FormGroup validationState={this.state.formErrors.referenceDate ? 'error' : null}>
                    <Row>
                        <Col sm={3} md={3} className="padding-top-10">
                            <ControlLabel>Edição de Rede</ControlLabel>
                        </Col>
                        <Col sm={9} md={9} className="padding-top-10 padding-left-25">
                            {edition.objects.network.name}
                        {this.state.formErrors.referenceDate && (
                            <HelpBlock>{this.state.formErrors.network}</HelpBlock>
                        )}
                        </Col>
                    </Row>
                </FormGroup>
            </div>
        );
    }

    renderPlanningsFilter(planningsType) {
        const { edition, actions } = this.state;

        if (!edition.objects.planning || edition.objects.planning.length === 0 || actions.isLoadingEdition) {
            return null;
        }

        const items = edition.objects.planning;
        const sortedItems = this.sortItems(items, this.getThisOrder(planningsType));
        const selectedItems = this.getAllPlanningEditions(planningsType);
        const updatedItems = this.updateItems(sortedItems, selectedItems);

        return (
            <div className="inline-label padding-top-7">
                <Row>
                    <Col sm={3} md={3} className="margin-left-15 padding-top-10" >
                        <ControlLabel>{planningsType.label}:</ControlLabel>
                    </Col>
                    <Col sm={9} md={9} className="margin-left--15">
                        <Select
                            className="custom-multiselect  padding-top-10"
                            placeholder="Sem Edição"
                            noOptionsMessage={() => "Sem Edições Configuradas"}
                            options={updatedItems}
                            onChange={(selectedOptions) => {
                                const value = selectedOptions ? selectedOptions.map(option => ({ id: option.id, name: option.name })) : null;
                                const property = this.getFormPropertyByLabel(planningsType.label);
                                this.onSelectValue(value, property);
                            }}
                            isMulti={true}
                            isClearable={true}
                            getOptionValue={(value) => value.id}
                            getOptionLabel={(label) => label.name}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    renderOptions(isWaiting) {
        const { form, parameters } = this.state;

        if (isWaiting) {
            return <LoadingSpinner />;
        }

        return (
            <React.Fragment>
                <FormGroup controlId="formActiveNetwork">
                    {this.renderActiveNetworkFilter()}
                </FormGroup>

                <FormGroup controlId="formPlannings">
                    <ControlLabel className="padding-top-15">Edições de Planeamento</ControlLabel>
                    <div className="padding-top-7">
                        {this.renderPlanningsFilter(form.plannings.schoolSeasonsPlanning)}
                        {this.renderPlanningsFilter(form.plannings.nonSchoolSeasonsPlanning)}
                        {this.renderPlanningsFilter(form.plannings.summerSeasonsPlanning)}
                    </div>
                </FormGroup>

                <FormGroup controlId="formRemove">
                    <Checkbox
                        className="form-checkbox pull-left"
                        defaultChecked={parameters.deleteSelections}
                        onChange={(e) => this.onCheckValue(e , "deleteSelections")}
                    >
                        Remover Seleções Existentes
                    </Checkbox>
                </FormGroup>

                <FormGroup>
                    <Row></Row>
                </FormGroup>
            </React.Fragment>
        );
    }

    render() {
        const { form, actions } = this.state;

        return (
            <React.Fragment>
                <Form>
                    <FormGroup controlId="formReferenceDate" validationState={this.state.formErrors.referenceDate ? 'error' : null}>
                        <Row className="padding-top-15">
                            <Col sm={3} md={3}>
                                <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                            </Col>
                            <Col sm={9} md={9}>
                                <DatePicker
                                    id="referenceDateDatePicker"
                                    dateFormat="DD/MM/YYYY"
                                    value={form.referenceDate}
                                    placeholder="Data de Referência"
                                    onChange={(e) => this.onChangeReferenceDateChange(e)}
                                />
                                {this.state.formErrors.referenceDate && (
                                    <HelpBlock>{this.state.formErrors.referenceDate}</HelpBlock>
                                )}
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>

                {this.renderOptions(actions.isLoadingEdition)}

                <ButtonToolbar>
                    <Button onClick={() => this.onContinue()}>CONTINUAR</Button>
                    <Button onClick={() => this.props.onCancel()}>CANCELAR</Button>
                </ButtonToolbar>
            </React.Fragment>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/bussched/schedules/tml/TmlUpdateSelectionForm.js